import { render, staticRenderFns } from "./addedit-escalationfactor.vue?vue&type=template&id=33b84f4d"
import script from "./addedit-escalationfactor.vue?vue&type=script&lang=js"
export * from "./addedit-escalationfactor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports